import React, { useRef, useState } from 'react'
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    top: '20%',
    bottom: '0px',
    right: '15%',
    left: 'revert',
    border: '0px solid red',
    borderRadius: '10px', padding: '0px',overflow:'hidden',
    backgroundRepeat: 'no-repeat',margin:0,
    height: 'fit-content', width: 'fit-content',
    "& .MuiDialog-container": {
      margin: 0,overflow:'hidden',
    },
    "& .MuiPaper-root": {
      margin: '0px !important',
      background: "white",
      border: '0px solid blue',
      borderRadius: '0px',
      maxWidth: '300px',
      maxHeight: '530px',
      height:'fit-content',
      overflow:'hidden',
            width:'fit-content'
    },
  }));
const VideoplaybackDialogForCampaignModal = (props) => {
    const { open, setOpen, preview } = props;
    const videoRef = useRef(null);

    const handleClose = () => {
      setOpen(false)
    };
  return (
   <BootstrapDialog
    onClose={handleClose}
    aria-labelledby="customized-dialog-title"
    open={open}><Box sx={{borderRadius:'10px',height:'fit-content',width:'fit-content',overflow:'hidden',padding:0,margin:0,position:'relative'}}>
        <video ref={videoRef} src={preview} controls style={{display: 'block',borderRadius:'10px',height:'fit-content',width:'100%',overflow:'hidden',}}>
            <source
                                                                                    src={
                                                                                        preview
                                                                                    }
                                                                                    type="video/mp4"
                                                                                    style={{height:'100%',width:'100%'}}
                                                                                />
                                                                                Your browser does not support the video
                                                                                tag.

        </video>
        </Box></BootstrapDialog>
  )
}

export default VideoplaybackDialogForCampaignModal